<template>
<div>
<v-layout row>
  <v-row class="row-footer" >
    <v-col cols="12" sm="8" lg="7" class="ml-2 text-center" align-self="center">
      <div cols="12" sm="3" md="2" lg="5" class="mt-4 select-footer">
        <v-select dense v-model="itemSelected" :items="itemsPerPage" color="#2196F3" class="select-pages"></v-select>
      </div>
      <v-btn icon :disabled="disableFirstPage" @click.stop="loadPage(1)" class="icon-size"> <v-icon medium>mdi-chevron-double-left</v-icon></v-btn>
      <v-btn icon :disabled="disablePrevious" @click.stop="previous" class="icon-size"> <v-icon medium>mdi-chevron-left</v-icon></v-btn>

      <v-btn text small rounded @click.stop="loadPage(page)" :class="{'btn-actived': actualPage === page}"
        v-for="page in pageWindow" :key="'page'+page" class="pa-0 ma-0 btn" >{{page}}</v-btn>

      <v-icon v-if="checkPages()" class="points">mdi-dots-horizontal</v-icon>
      <v-btn icon :disabled="disableNext" @click="next" class="icon-size"> <v-icon medium>mdi-chevron-right</v-icon></v-btn>
      <v-btn icon :disabled="disableLastPage" @click.stop="loadPage(pages)" class="icon-size"> <v-icon medium>mdi-chevron-double-right</v-icon></v-btn>

    </v-col>
  </v-row>
  
</v-layout>
<v-layout v-if="selectedStatistic === $t('system')">
  <v-row class="system-info">
    *{{$t('onlySuccessfully')}}
  </v-row>
</v-layout>
</div>
</template>

<script>
export default {
  props:{
    tableInfo: {
      type: Function,
      default: function(){return undefined}
    },
    search: {
      type: String,
      default: ''
    },
    status: {
      type:String,
      default: ''
    },
    rangeDate: {
        type: String,
        default: function () {
            return 'month';
        },
    },
    requestPeriodically: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      pages: Number,
      pageWindow: [],
      //always eneven numbers
      maxPages:5,
      pageOffset: 0,
      disablePrevious: true,  
      disableNext: false,
      //itemSelected:10,  
      itemsPerPage: [5,10,15],
      interval: undefined,
      isActive: true
    }
  },
  mounted(){
    this.actualPage = this.page
    this.disablePrevious = (this.actualPage == 1)
    this.callPagingInfo()
    if(this.requestPeriodically){
      this.interval = setInterval(this.callPagingInfo, 60000)   
    }
  },
  computed: {
    disableFirstPage(){
      if(this.pages <= this.maxPages )
        return true
      if(this.actualPage > Math.ceil(this.maxPages/2))
        return false
      else 
        return true
    },
    disableLastPage(){
      if(this.pages <= this.maxPages )
        return true
      if(this.actualPage < this.pages - Math.floor(this.maxPages/2))
        return false
      else 
        return true
    },
    page: {
      get(){
        return this.$store.getters.getPage
      },
      set(value){
        return this.$store.commit('setPage', value)
      }
    },
    itemSelected: {
      get(){
        return this.$store.getters.getSelectedItemsPerPage
      },
      set(value){
        return this.$store.commit('setSelectedItemsPerPage', value)
      }
    },
    actualPage: {
      get(){
        return this.$store.getters.getActualPage
      },
      set(value){
        return this.$store.commit('setActualPage', value)
      }
    },
    start: {
        get(){
            return this.$store.getters.getStartDate
        },
        set(value){
            return this.$store.commit('setStartDate', value)
        }
    },
    rangeDates: {
        get(){
            return this.$store.getters.getRange
        },
        set(value){
        return this.$store.commit('setRange', value)
      }
    },
    selectedStatistic: {
      get() {
        return this.$store.getters.getSelectedStatistic;
      },
      set(value) {
        return this.$store.commit("setSelectedStatistic", value);
      },
    }
  },
  watch:{
    itemSelected: function(newVal, oldVal){
      if(newVal === oldVal){
        return null
      }
      clearInterval(this.interval)  
      this.interval = undefined
      this.tableInfo(this.itemSelected, this.search, this.status, this.rangeDate).then(response=>{
        this.pages = response.data
        this.calculatePageWindow()
      })
      
      if(this.requestPeriodically){
        this.interval = setInterval(this.tableInfo(this.itemSelected, this.search, this.status, this.rangeDate).then(response=>{
          this.pages = response.data
          this.calculatePageWindow()
        }), 5000)
      }
      this.$emit('callback',this.actualPage, this.itemSelected, this.status, this.rangeDate)
    },
    start: function(newVal, oldVal) {
        if(newVal != oldVal){
            this.callPagingInfo()
        }
    },
    rangeDates: function(newVal, oldVal) {
        if(newVal != oldVal){
            this.callPagingInfo()
        }
    }
  },
  beforeDestroy(){
    clearInterval(this.interval)
    this.interval = undefined
  },
  methods:{
    calculatePageWindow(){
      let medioVentana = Math.ceil(this.maxPages/2)
      let anchoVentana = Math.floor(this.maxPages/2)
      if(this.actualPage <= medioVentana){
        this.pageWindow =  this.range(1)
      }else if((this.actualPage + anchoVentana) > this.pages){
        this.pageWindow =  this.range(this.actualPage - (anchoVentana + (this.actualPage + anchoVentana - this.pages)))
      }else{
        this.pageWindow =  this.range(this.actualPage-anchoVentana)
      }      
    }, 
    range(from) {
      var numbers = []
      var init = from
      var max = from+this.maxPages-1
      if(this.maxPages>this.pages){
        init = 1
        max = this.pages
      }       
      for(let i=init; i <= max; i++){
        numbers.push(i)
      }
      return numbers
    },
    async callPagingInfo(){
      await this.tableInfo(this.itemSelected, this.search, this.status, this.rangeDate).then(response=>{
        this.pages = (response.data > 0)? response.data : 1
        this.disableNext = (this.actualPage == this.pages)
        this.calculatePageWindow()
      })  
    },
    next(){
      this.actualPage ++
      this.calculatePageWindow()
      this.disablePrevious = (!this.actualPage>1)
      this.disableNext =(this.actualPage == this.pages)
      this.$emit('callback',this.actualPage, this.itemSelected, this.status, this.rangeDate)
    },
    previous(){
      this.actualPage --
      this.calculatePageWindow()
      if(this.actualPage > 0) {
        this.disableNext= false
        this.disablePrevious = (this.actualPage===1)
        this.$emit('callback',this.actualPage, this.itemSelected, this.status, this.rangeDate)
      } else{
        this.actualPage = 1
        this.disablePrevious = true
      }
    },
    loadPage(pageSelected){
      this.actualPage = pageSelected
      this.disablePrevious = (this.actualPage===1)
      this.disableNext = (this.actualPage == this.pages)
      this.calculatePageWindow()
      this.$emit('callback',pageSelected, this.itemSelected, this.status, this.rangeDate)
    },
    stepBack(pageRequest){
      this.actualPage = pageRequest
      this.calculatePageWindow()
      this.disableNext = true
      if(this.actualPage===1)
        this.disablePrevious = true
    },
    checkPages(){
      if(this.pages === this.maxPages){
        return false
      }
      if(this.actualPage < this.pages - Math.floor(this.maxPages/2) ){
        return true
      } else{
        return false
      }
    },
    emitCallBack(){
      this.$emit('callback',this.actualPage, this.itemSelected, this.status, this.rangeDate)
    }
  }

}
</script>
<style>
  .select-footer{
    margin-right: 10px!important;
    display: inline-flex!important;
    text-align: right!important;
  }
  .select-pages{
      width: 50%!important;
    }
  .select-pages .v-select__slot{
    width: 50px!important;
  }
  .select-pages .v-input__slot::before{
    width: 35%!important;
  }
  .select-pages .v-input__slot{
    width: 100%!important;
  }
  .select-pages .v-input__slot::after{
    width: 35%!important;
  }
  .v-select__selections{
    font-size: 12px!important;
  }
  .row-footer{
    justify-content: flex-end!important;
  }
  .btn-actived{
    color: #0d5ae5!important;
    background-color: #d3eafb!important;
  }
  .btn{
    min-width: 30px!important;
  }
  .points{
    margin-top: 9px!important;
    font-size: 20px!important;
  }
  .system-info{
    justify-content: flex-end!important;
    margin-right: 10px!important;
    font-size: 11px!important;
  }
  .select-pages{
    text-align: right!important;
  }
  @media (max-width: 950px) {
    .row-footer{
      justify-content: center!important;
    }
    .select-pages{
      width: 50%!important;
    }
  }
  @media (max-width: 599px) {
    .select-pages{
      margin: 0 auto;
    }
    .select-footer{
      display:block!important;
      text-align: center!important;
    }
    .select-pages{
      width: 35%!important;
      padding-left: 35px!important;
    }
  }
  @media (max-width: 390px) {
    .btn{
      min-width: 30px!important;
    }
    .select-page .v-input__control{
      width: 50%!important;
    }
    .select-page .v-input__slot{
      width: 40%!important;
    }
  }
   @media (max-width: 340px) {
    .btn{
      min-width: 20px!important;
    }
    .icon-size{
      width: 20px!important;
    }
    .select-page .v-input__control{
      width: 60%!important;
    }
    .select-page .v-input__slot{
      width: 50%!important;
    }
  }
</style>